import { useEffect, useState, useCallback } from "react";

const KEY = "guzzardella_compare_v1";
const MAX = 3;

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter((x) => typeof x === "string") : [];
  } catch {
    return [];
  }
};

const write = (ids) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(ids.slice(0, MAX)));
    window.dispatchEvent(new CustomEvent("compare:change"));
  } catch {
    /* ignore */
  }
};

export const MAX_COMPARE = MAX;

export const useCompare = () => {
  const [ids, setIds] = useState(read);

  useEffect(() => {
    const onChange = () => setIds(read());
    window.addEventListener("compare:change", onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener("compare:change", onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);

  const has = useCallback((id) => ids.includes(id), [ids]);

  const toggle = useCallback((id) => {
    const current = read();
    let next;
    if (current.includes(id)) {
      next = current.filter((x) => x !== id);
    } else {
      if (current.length >= MAX) return { added: false, reason: "max" };
      next = [...current, id];
    }
    write(next);
    setIds(next);
    return { added: !current.includes(id), reason: null };
  }, []);

  const clear = useCallback(() => {
    write([]);
    setIds([]);
  }, []);

  const remove = useCallback((id) => {
    const next = read().filter((x) => x !== id);
    write(next);
    setIds(next);
  }, []);

  return { ids, has, toggle, clear, remove, count: ids.length, max: MAX };
};
